



























import { PublicCourseDetails } from '@/jbi-shared/dto/jtms-public-course.dtos';
import { CourseLocation } from '@/jbi-shared/types/jtms.types';
import { formatDateTime } from '@/jbi-shared/util/group-level-attributes.util';
import { RootState } from '@/store/store';
import { Vue, Component } from 'vue-property-decorator';
import { Getter, State } from 'vuex-class';
import MandatoryQuestionnaireInfoBox from './MandatoryQuestionnaireInfoBox.vue';

@Component({
  components: {
    MandatoryQuestionnaireInfoBox
  }
})
export default class EventHeader extends Vue {
  @Getter('course/hasQuestionnaire')
  hasQuestionnaire!: boolean;

  @State(({ course }: RootState) => course.publicCourseState.courseDetails)
  public publicCourseDetails!: PublicCourseDetails;

  get title(): string {
    return this.publicCourseDetails.courseName;
  }

  get formattedDate(): string {
    const dateFromState = this.publicCourseDetails.courseStartDate;
    const options: Intl.DateTimeFormatOptions = {
      month: 'long',
      year: 'numeric'
    };
    return formatDateTime(
      dateFromState as string,
      undefined,
      undefined,
      options
    );
  }

  get isRemote(): boolean {
    return this.publicCourseDetails.locationType === CourseLocation.REMOTE;
  }

  get locationText(): string {
    return this.isRemote ? 'Online Event' : this.publicCourseDetails.location!;
  }

  get locationIcon(): string {
    return this.isRemote ? 'television-play' : 'map-marker';
  }

  get formattedDateRange(): string {
    return [
      this.publicCourseDetails.courseStartDate,
      this.publicCourseDetails.courseEndDate
    ].join(' to ');
  }
}
